(function () {
  const SELECTORS = [
    '.card__author',
    '.card__title',
    '.catalog-price-table',
    '.card-total-wrapper',
  ];
  const GRID_SELECTOR = '.main-products-grid[data-layout="grid"] .grid, .cc-product-card-grid .grid:not(.slider__grid)';
  const CARD_SELECTOR = '.card--product';
  const DEBOUNCE_MS = 150;

  function groupCardsByRow(cards) {
    const rows = [];
    let currentRow = [];
    let currentTop = null;
    const tolerance = 5;

    for (const card of cards) {
      const rect = card.getBoundingClientRect();
      if (currentTop === null || Math.abs(rect.top - currentTop) > tolerance) {
        if (currentRow.length) rows.push(currentRow);
        currentRow = [card];
        currentTop = rect.top;
      } else {
        currentRow.push(card);
      }
    }
    if (currentRow.length) rows.push(currentRow);
    return rows;
  }

  function equalizeRow(cards) {
    for (const selector of SELECTORS) {
      const elements = cards.map(function (card) {
        return card.querySelector(selector);
      });

      elements.forEach(function (el) {
        if (el) el.style.minHeight = '';
      });

      let maxHeight = 0;
      elements.forEach(function (el) {
        if (el) {
          const h = el.getBoundingClientRect().height;
          if (h > maxHeight) maxHeight = h;
        }
      });

      if (maxHeight > 0) {
        elements.forEach(function (el) {
          if (el) el.style.minHeight = maxHeight + 'px';
        });
      }
    }
  }

  function resetCards(cards) {
    for (const selector of SELECTORS) {
      cards.forEach(function (card) {
        var el = card.querySelector(selector);
        if (el) el.style.minHeight = '';
      });
    }
  }

  function resetAllCards() {
    document.querySelectorAll('.main-products-grid .grid, .cc-product-card-grid .grid:not(.slider__grid)').forEach(function (grid) {
      var cards = Array.from(grid.querySelectorAll(':scope > li > ' + CARD_SELECTOR));
      resetCards(cards);
    });
  }

  function alignCards() {
    var grids = document.querySelectorAll(GRID_SELECTOR);
    if (!grids.length) {
      resetAllCards();
      return;
    }

    grids.forEach(function (grid) {
      var cards = Array.from(grid.querySelectorAll(':scope > li > ' + CARD_SELECTOR));
      if (cards.length < 2) return;

      resetCards(cards);

      var rows = groupCardsByRow(cards);
      rows.forEach(function (row) {
        if (row.length > 1) equalizeRow(row);
      });
    });
  }

  function debounce(fn, ms) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, ms);
    };
  }

  var debouncedAlign = debounce(alignCards, DEBOUNCE_MS);

  document.addEventListener('DOMContentLoaded', function () {
    alignCards();

    var filterResults = document.getElementById('filter-results');
    if (filterResults) {
      new MutationObserver(debouncedAlign).observe(filterResults, {
        childList: true,
        subtree: true,
      });
    }

    var productsGrid = document.querySelector('.main-products-grid');
    if (productsGrid) {
      new MutationObserver(debouncedAlign).observe(productsGrid, {
        attributes: true,
        attributeFilter: ['data-layout'],
      });
    }
  });

  window.addEventListener('resize', debouncedAlign);

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    alignCards();
  }
})();
